import React from 'react';
import { Hero } from '../components/Hero';
import { MarqueeBand } from '../components/MarqueeBand';
import { FeaturedProperties } from '../components/FeaturedProperties';
import { Mission } from '../components/Mission';
import { WhyChoose } from '../components/WhyChoose';
import { Stats } from '../components/Stats';
import { Process } from '../components/Process';
import { Testimonials } from '../components/Testimonials';
import { Partners } from '../components/Partners';
import { BookInspection } from '../components/BookInspection';
export function Home() {
  return <>
      <Hero data-id="element-1140" />
      <MarqueeBand data-id="element-1141" />
      <FeaturedProperties data-id="element-1142" />
      <Mission data-id="element-1143" />
      <WhyChoose data-id="element-1144" />
      <Stats data-id="element-1145" />
      <Process data-id="element-1146" />
      <Testimonials data-id="element-1147" />
      <Partners data-id="element-1148" />
      <BookInspection data-id="element-1149" />
    </>;
}